import get from 'lodash/get';

const mutations = {
	setStep(state, payload) {
		const forward = payload > state.step;
		this._vm.$set(state, 'step', payload);
		this._vm.$set(state, 'forward', forward);
	},
	complete(state, complete = true) {
		this._vm.$set(state, 'complete', Boolean(complete));
	},
	extraFeatures(state, payload) {
		let val = [];
		if (-1 === state.extraFeatures.indexOf(payload)) {
			val = [...state.extraFeatures, payload];
		} else {
			val = [
				...state.extraFeatures.filter((v) => {
					return v !== payload;
				}),
			];
		}

		this._vm.$set(state, 'extraFeatures', val);
	},
	resetExtraFeatures(state, payload) {
		this._vm.$set(state, 'extraFeatures', payload);
	},
	resetState(state, payload) {
		Object.assign(state, payload);
	},
	setPricingPlans(state, payload) {
		const origPlans = get(state, 'pricing.plans', []);

		Object.keys(payload).forEach((level) => {
			const plan = payload[level];
			plan.level = level;

			origPlans.push(plan);
		});

		this._vm.$set(state.pricing.plans, origPlans);
	},
};

export default mutations;
